import { lazy } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { AuthedOutlet } from "./components/layouts/authed-layout";
import { CenteredLayout } from "./components/layouts/centered-layout";

// Lazy load page components
const Login = lazy(() =>
	import("./components/pages/login").then((m) => ({ default: m.Login })),
);
const Dashboard = lazy(() =>
	import("./components/pages/dashboard").then((m) => ({
		default: m.Dashboard,
	})),
);
const PushNotifications = lazy(() =>
	import("./components/pages/push-notifications").then((m) => ({
		default: m.PushNotifications,
	})),
);
const PushNotificationDetails = lazy(() =>
	import("./components/pages/push-notification-details").then((m) => ({
		default: m.PushNotificationDetails,
	})),
);
const DevicesPage = lazy(() =>
	import("./components/pages/devices").then((m) => ({
		default: m.DevicesPage,
	})),
);
const GroupsPage = lazy(() =>
	import("./components/pages/groups").then((m) => ({ default: m.GroupsPage })),
);
const MembersPage = lazy(() =>
	import("./components/pages/members").then((m) => ({
		default: m.MembersPage,
	})),
);
const InvitesPage = lazy(() =>
	import("./components/pages/invites").then((m) => ({
		default: m.InvitesPage,
	})),
);
const InvitePage = lazy(() =>
	import("./components/pages/invite").then((m) => ({
		default: m.InvitePage,
	})),
);
const RegisterPage = lazy(() =>
	import("./components/pages/register").then((m) => ({
		default: m.RegisterPage,
	})),
);

const ReimbursementsPage = lazy(() =>
	import("./components/pages/reimbursements").then((m) => ({
		default: m.ReimbursementsPage,
	})),
);

export const router = createBrowserRouter([
	{
		path: "/",
		Component: () => <Outlet />,
		children: [
			{
				index: true,
				Component: () => <Navigate to="/login" />,
			},
		],
	},
	{
		path: "/login",
		Component: CenteredLayout,
		children: [
			{
				index: true,
				Component: Login,
			},
		],
	},
	{
		path: "register",
		Component: CenteredLayout,
		children: [
			{
				path: ":inviteCode",
				Component: RegisterPage,
			},
		],
	},
	{
		path: "invite",
		Component: CenteredLayout,
		children: [
			{
				path: ":inviteCode",
				Component: InvitePage,
			},
		],
	},
	{
		path: "/dashboard",
		Component: AuthedOutlet,
		children: [
			{
				index: true,
				Component: Dashboard,
			},
			{
				path: "push-notifications",
				Component: PushNotifications,
			},
			{
				path: "push-notifications/:id",
				Component: PushNotificationDetails,
			},
			{
				path: "devices",
				Component: DevicesPage,
			},
			{
				path: "groups",
				Component: GroupsPage,
			},
			{
				path: "members",
				Component: MembersPage,
			},
			{
				path: "invites",
				Component: InvitesPage,
			},
			{
				path: "reimbursements",
				Component: ReimbursementsPage,
			},
		],
	},
]);
